import { Box, Divider, Grid } from '@mui/material'
import React from 'react'

import { DrawerUserDetail } from 'components/navigation/Nav/DrawerUserDetail'
import useAuth from 'hooks/use-auth'
import { trans } from 'i18n/translate'
import { colors } from 'mui-theme/theme'
import theme from 'theme'
import { getUserDisplayName } from 'utils/user'

export const DrawerUserInfo: React.FC = ({ ...rest }) => {
  const { companyDisplayName, companyId, currentTeam, currentTeamId, session } =
    useAuth()

  return (
    <Box {...rest}>
      <Divider sx={{ backgroundColor: colors.primary[200] }} />
      <Grid
        container
        columnSpacing={1}
        css={{
          color: theme.colors.white[0],
          padding: theme.space[4]
        }}
        rowSpacing={1}
      >
        {getUserDisplayName(session) && (
          <DrawerUserDetail
            iconName="solidUser"
            text={getUserDisplayName(session)}
          />
        )}
        {currentTeam?.name && (
          <DrawerUserDetail
            clipboardOptions={{
              content: currentTeamId,
              tooltipText: trans(
                'navigation.drawer_user_info.drawer_user_detail.team_clipboard_text'
              )
            }}
            iconName="solidUserGroup"
            text={currentTeam?.name}
          />
        )}
        {companyDisplayName && (
          <DrawerUserDetail
            clipboardOptions={{
              content: companyId,
              tooltipText: trans(
                'navigation.drawer_user_info.drawer_user_detail.company_clipboard_text'
              )
            }}
            iconName="solidBuilding"
            text={companyDisplayName}
          />
        )}
      </Grid>
    </Box>
  )
}
